import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/SettingProductCompany';

const getSettingProductCompanyReducer = handleActions({
    [Actions.GetSettingProductCompanyRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetSettingProductCompanyRequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetSettingProductCompanyRequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearSettingProductCompany]: () => ({
        isFetching: false,
        errors: {},
        data: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const updateSettingProductCompanyReducer = handleActions({
    [Actions.UpdateSettingProductCompanyRequested]: (state) => ({
        ...state,
        isFetching: true,
        updateSuccess: false,
    }),
    [Actions.UpdateSettingProductCompanyRequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        updateSuccess: true,
    }),
    [Actions.UpdateSettingProductCompanyRequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        updateSuccess: false,
    }),
    [Actions.ClearUpdate]: () => ({
        isFetching: false,
        data: {},
        errors: {},
        updateSuccess: false,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    updateSuccess: false,
});

export default combineReducers({
    get: getSettingProductCompanyReducer,
    update: updateSettingProductCompanyReducer,
});
